module.exports = __webpack_public_path__ + "static/media/ucla-logo.b47b1710.png";